export default function IconText({ className }: { className?: string }) {
	return (
		<svg viewBox="-0.5 -0.5 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" id="Text--Streamline-Solar-Ar" height="16" width="16" className={className}>
			<desc>Text Streamline Icon: https://streamlinehq.com</desc>
			<path
				d="M7.5 1.875H5c-1.1785125 0 -1.76776875 0 -2.13388125 0.36611875000000005C2.5 2.60723125 2.5 3.1964875 2.5 4.375v0.59375M7.5 1.875h2.5c1.1784999999999999 0 1.76775 0 2.133875 0.36611875000000005C12.5 2.60723125 12.5 3.1964875 12.5 4.375v0.59375M7.5 1.875v11.25"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1"
			></path>
			<path d="M4.375 13.125h6.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path>
		</svg>
	);
}
